import React, { useState } from 'react';
import './UploadDocument.css';
import Navbar from '../../components/Navbar/Navbar';
import API_URL from '../../config/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getUsername } from '../../utils/auth';
import Footer from '../../components/Footer/Footer';

const TIPO_RELATORIO_VALIDACAO = 'Relatórios de Validação';
const TIPO_NOTAS_TECNICAS = 'Notas Técnicas';

const formatarCodigoBe = valor => {
  const somenteNumeros = String(valor ?? '').replace(/\D/g, '');

  if (!somenteNumeros) return '';

  const numero = Number.parseInt(somenteNumeros, 10);
  if (!Number.isSafeInteger(numero) || numero <= 0) return '';

  return `BE${String(numero).padStart(2, '0')}`;
};

const UploadDocument = () => {
  const [file, setFile] = useState(null);
  const [tipoDocumento, setTipoDocumento] = useState('');
  const [origemDocumento, setOrigemDocumento] = useState('');
  const [numeroBe, setNumeroBe] = useState('');
  const navigate = useNavigate();

  const opcoesOrigem = {
    Administrativos: ['Contrato', 'Termo de Consórcio', 'Matriz de Risco', 'Matriz de Comunicação', 'Matriz de Documentos'],
    Meteorologicas: ['METAR', 'Imagens de Satélite', 'Galeria de Fotos', 'Relatório Mensal de CM'],
    Registros: ['Ata de Reunião', 'Registros de Comunicação'],
    Tecnicos: ['Planejamento', 'Execução', 'Validação'],
    [TIPO_NOTAS_TECNICAS]: [
      TIPO_NOTAS_TECNICAS,
      'Respostas Notas Técnicas',
    ],
    Indicadores: [' Administrativo', 'Físico', 'Planejamento'],
    Financeiro: ['Boletim de Entrega', 'Boletim de Medição', 'Relatório de Avanço Financeiro'],
    'Modelo De Arquivos': [
      'Modelo de Marco',
      'Modelo de Monografia',
      'Modelo Planilha de Coordenadas Classe I',
      'Modelo Planilha de Coordenadas Classe II',
      'Modelo de Planilha Rastreio GPS/ GNSS',
      'Modelo de Planilha Fechamento de Transporte de Coordenadas',
      'Modelo de Planilha de Voo LASER',
      'Modelo de Planilha Voo FOTO',
      'Modelo de Planilha de Controle LASER',
      'Modelo de Planilha de Controle FOTO',
      'Modelo de Planilha de Relatório de Bordo LASER',
      'Modelo de Planilha de Relatório de Bordo FOTO',
      'Modelo de Relatório Meteorológico',
      'Modelo de Relatório de Execução',
      'Manual de Modelo de Pastas e Nomenclaturas',
    ],
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!file || !tipoDocumento || !origemDocumento) {
      return toast.warn('Preencha todos os campos.');
    }

    const token = JSON.parse(atob(localStorage.getItem('token') || '""'));

    const formData = new FormData();
    formData.append('file', file);
    formData.append('tipo', tipoDocumento);
    formData.append('origem', origemDocumento);
    formData.append('usuarioUpload', getUsername());

    try {
      const response = await fetch(`${API_URL}/api/Documentos/upload`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toast.info('Upload realizado com sucesso!');
        navigate('/documents');
      } else if (response.status === 401) {
        toast.error('Sessão expirada, faça login novamente.');
        localStorage.clear();
        navigate('/');
      } else if (response.status === 403) {
        toast.warn('Acesso negado.');
      } else {
        const errorData = await response.json();
        toast.error(`Erro ao fazer upload: ${errorData.error || response.statusText}`);
        navigate('/documents');
      }
    } catch (error) {
      toast.error(`Erro de conexão: ${error.message}`);
      navigate('/documents');
    }
  };

  const handleCheckboxChange = (tipo, origem) => {
    setTipoDocumento(tipo);
    setOrigemDocumento(origem);
    setNumeroBe('');
  };

  const handleBeChange = event => {
    const valorDigitado = event.target.value.replace(/\D/g, '');
    const codigoBe = formatarCodigoBe(valorDigitado);

    setNumeroBe(valorDigitado);

    if (codigoBe) {
      setTipoDocumento(TIPO_RELATORIO_VALIDACAO);
      setOrigemDocumento(codigoBe);
    } else {
      setTipoDocumento('');
      setOrigemDocumento('');
    }
  };

  return (
    <div className="page-layout">
      <Navbar />
      <div className="page-content">
        <form onSubmit={handleSubmit} className="upload-container">
          <h2>Upload de Documento</h2>

          <label>Arquivo:</label>
          <input type="file" onChange={e => setFile(e.target.files[0])} />

          <label>Selecione a Origem do Documento:</label>
          <div className="grid-checkboxes">
            <div className="checkbox-column validation-report-column">
              <strong>{TIPO_RELATORIO_VALIDACAO}</strong>
              <label htmlFor="numero-be" className="be-label">
                Número do BE
              </label>
              <div className="be-input-wrapper">
                <span>BE</span>
                <input
                  id="numero-be"
                  type="text"
                  inputMode="numeric"
                  value={numeroBe}
                  onChange={handleBeChange}
                  placeholder="Ex.: 03"
                  aria-describedby="be-preview"
                />
              </div>
              <small id="be-preview" className="be-preview">
                {origemDocumento && tipoDocumento === TIPO_RELATORIO_VALIDACAO
                  ? `Destino selecionado: ${origemDocumento}`
                  : 'Informe qualquer número positivo, como 03, 24 ou 25.'}
              </small>
            </div>

            {Object.entries(opcoesOrigem).map(([tipo, origens]) => (
              <div key={tipo} className="checkbox-column">
                <strong>{tipo}</strong>
                {origens.map(origem => (
                  <label key={`${tipo}-${origem}`} className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={
                        tipoDocumento === tipo && origemDocumento === origem
                      }
                      onChange={() => handleCheckboxChange(tipo, origem)}
                    />
                    {origem}
                  </label>
                ))}
              </div>
            ))}
          </div>

          <button type="submit">Enviar</button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default UploadDocument;
